// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"504":"62d75cff","729":"4d022aba"}[chunkId] || chunkId) + "." + {"504":"51f6ea96038effea","621":"9e6bfbf47b938a53","647":"8793bae19825f80f","729":"5bf90dddbf4ac190"}[chunkId] + ".js";
};